import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { contractActions, alertActions, contracterActions } from '../../../store/actions'

import InfiniteList from 'react-infinite-scroll-list'
import Pagination from '../../../module/pagination/'

import TestData from '../../../test.json'

const CertificateInboxOrigin = props => {

  return(
    <React.Fragment>
      <div className="detail-table">

        <div className="service-title">
            <Link title="이전페이지로 이동" to="/service/inbox"><button className="btn btn-white btn-pre"><span>이전페이지로 이동</span></button></Link>
            전자증명서 진본검증
        </div>

        <div className="service-table certificate-list">
          <div className="detail-title">발급이력</div>
          {/*<div className="header">*/}

          <div className="service-table-scroll">
            <div className="inner">
              <div className="scroll">
                <div className="row">
                  <ul className="flex-col">
                    <li className="col title">
                      <div>증명서</div>
                      <div>구매확인서 | KFK2143823 </div>
                    </li>
                    <li className="col title">
                      <div>발급</div>
                      <div>전자무역포털</div>
                    </li>
                    <li className="col title">
                      <div>시점확인 전자서명해시</div>
                      <div>34858495023</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="service-table certificate-list">
          <div className="detail-title">시점확인</div>
          {/*<div className="header">*/}

          <div className="service-table-scroll">
            <div className="inner">
              <div className="scroll">
                <div className="row">
                  <ul className="flex-col">
                    <li className="col title">
                      <div>시점확인(타임스탬프) 시간</div>
                      <div>2021/01/05 </div>
                    </li>
                    <li className="col title">
                      <div>전자서명</div>
                      <div>한국무역정보통신</div>
                    </li>
                    <li className="col title">
                      <div>시점확인 전자서명해시</div>
                      <div>34858495023</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    contract: state.contract,
    pagination: state.pagination
  }
}

const actionCreators = {
  load: contractActions.load,
  select: contractActions.select,
  record: contractActions.record,
  keepOpen: contractActions.keepOpen,
  setContracter: contracterActions.setContracter,
  confirm: alertActions.confirm
}

export default connect(
  mapStateToProps,
  actionCreators
)(CertificateInboxOrigin)
